import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Sparkles, RefreshCw, ArrowRight } from "lucide-react";
import { api } from "@/lib/api";

export const PromoNudge = () => {
  const [nudge, setNudge] = useState(null);
  const [busy, setBusy] = useState(false);

  const load = useCallback((refresh = false) => {
    setBusy(true);
    api.get(`/nudge${refresh ? "?refresh=true" : ""}`)
      .then((r) => setNudge(r.data))
      .catch((e) => console.warn("Nudge unavailable", e))
      .finally(() => setBusy(false));
  }, []);

  useEffect(() => { load(); }, [load]);

  if (!nudge && !busy) return null;
  return (
    <section
      className="panel relative overflow-hidden p-5 flex flex-col sm:flex-row sm:items-center gap-4 border-amber-500/30 fade-up"
      style={{ background: "linear-gradient(100deg, rgba(255,193,7,0.10), rgba(0,240,255,0.04) 70%)" }}
      data-testid="promo-nudge"
    >
      <div className="w-10 h-10 rounded-xl grid place-items-center bg-amber-400/15 text-amber-400 shrink-0">
        <Sparkles size={18} />
      </div>
      <div className="flex-1 min-w-0">
        <div className="text-[10px] uppercase tracking-widest text-amber-400/80">Concierge tip</div>
        {nudge ? (
          <p className="text-sm md:text-base text-white mt-1" data-testid="promo-nudge-text">{nudge.tip}</p>
        ) : (
          <div className="h-4 mt-2 w-2/3 rounded bg-white/[0.06] animate-pulse" data-testid="promo-nudge-loading" />
        )}
      </div>
      <div className="flex items-center gap-2 shrink-0">
        {nudge && (
          <Link to={nudge.cta_path} className="btn-gold rounded-lg text-xs py-2 px-4 flex items-center gap-1.5" data-testid="promo-nudge-cta">
            {nudge.cta_label} <ArrowRight size={14} />
          </Link>
        )}
        <button
          onClick={() => load(true)}
          disabled={busy}
          className="p-2 rounded-lg text-zinc-500 hover:text-amber-400 hover:bg-white/[0.05] transition-colors disabled:opacity-40"
          aria-label="New tip"
          data-testid="promo-nudge-refresh"
        >
          <RefreshCw size={14} className={busy ? "animate-spin" : ""} />
        </button>
      </div>
    </section>
  );
};
